import React from "react";
import { Radio } from 'antd';
import { IntlContext } from "../../IntlContext";

const LanguageSwitch = ({ history }) => {
  const { locale } = React.useContext(IntlContext);
  return (
    <Radio.Group size="small" value={locale} onChange={(e) => history.push('/' + e.target.value)} style={{ marginRight: 16 }}>
      <Radio.Button value="en">EN</Radio.Button>
      <Radio.Button value="nl">NL</Radio.Button>
    </Radio.Group>
  );
};

export default LanguageSwitch;